import React from "react";

const STYLE = {
  draft: "bg-gray-100 text-gray-700 border-gray-300",
  awaiting_deposit: "bg-amber-50 text-amber-700 border-amber-200",
  pending_deposit: "bg-amber-50 text-amber-700 border-amber-200",   // legacy alias
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  matched: "bg-blue-50 text-blue-700 border-blue-200",
  selected: "bg-indigo-50 text-indigo-700 border-indigo-200",
  awaiting_funding: "bg-orange-50 text-orange-700 border-orange-200",
  funded: "bg-purple-50 text-purple-700 border-purple-200",
  claimed: "bg-purple-50 text-purple-700 border-purple-200",         // legacy alias
  expired: "bg-slate-100 text-slate-700 border-slate-300",
  cancelled: "bg-slate-100 text-slate-700 border-slate-300",
  withdrawn: "bg-slate-100 text-slate-700 border-slate-300",         // legacy alias
  forfeited: "bg-red-50 text-red-700 border-red-200",
};
const LABEL = {
  draft: "Draft", awaiting_deposit: "Awaiting Deposit",
  pending_deposit: "Awaiting Deposit", active: "Active",
  matched: "Matched", selected: "Selected",
  awaiting_funding: "Awaiting Funding", funded: "Funded", claimed: "Funded",
  expired: "Expired", cancelled: "Cancelled", withdrawn: "Cancelled",
  forfeited: "Forfeited",
};

export default function PreapprovalStatusPill({ status }) {
  return (
    <span className={`px-2 py-0.5 border text-[10px] font-overline ${STYLE[status] || "bg-gray-100 border-gray-300"}`}
      data-testid={`pa-status-${status}`}>
      {LABEL[status] || status}
    </span>
  );
}
